import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { db } from "../firebase";
import {
  collection, getDocs, query, where, doc, updateDoc
} from "firebase/firestore";

/**
 * Returns { hasAccess, loading } for the offer letter editor.
 * - Superadmin: always has access
 * - Admin: access only if userData.offerLetterAccess === true in Firestore
 * - Employee: never has access
 */
const useOfferLetterAccess = () => {
  const { userData, loading: authLoading } = useAuth();
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!userData) {
      setHasAccess(false);
      setLoading(false);
      return;
    }
    if (userData.role === "superadmin") {
      setHasAccess(true);
    } else if (userData.role === "admin" && userData.offerLetterAccess === true) {
      setHasAccess(true);
    } else {
      setHasAccess(false);
    }
    setLoading(false);
  }, [userData, authLoading]);

  return { hasAccess, loading };
};

export default useOfferLetterAccess;
